module.exports = __webpack_public_path__ + "img/profile-not-verified.792980fa.svg";